import * as types from "./actionTypes";

export const setShopPageLoaded = (shopPageLoaded) => ({
  type: types.SET_SHOP_PAGE_LOADED,
  payload: {shopPageLoaded}
})
export const setShopPageOpened = (shopPageOpened) => ({
  type: types.SET_SHOP_PAGE_OPENED,
  payload: {shopPageOpened}
})
export const setShopLastPageVisited = (shopLastPageVisited) => ({
  type: types.SET_SHOP_LAST_PAGE_VISITED,
  payload: {shopLastPageVisited}
})
export const setShopPageLeaved = (shopPageLeaved) => ({
  type: types.SET_SHOP_PAGE_LEAVED,
  payload: {shopPageLeaved}
})

// export const setShopActiveCategory = (shopActiveCategory) => ({
//   type: types.SET_SHOP_ACTIVE_CATEGORY,
//   payload: {shopActiveCategory}
// })
//
// export const setShopActiveFeature = (shopActiveFeature) => ({
//   type: types.SET_SHOP_ACTIVE_FEATURE,
//   payload: {shopActiveFeature}
// })
